import { render, staticRenderFns } from "./BaseSections.vue?vue&type=template&id=75fed48a&"
import script from "./BaseSections.vue?vue&type=script&lang=js&"
export * from "./BaseSections.vue?vue&type=script&lang=js&"
import style0 from "./BaseSections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports